import Button from '@blocks/Button'
import Hamburger from '@blocks/Hamburger'
import Logo from '@blocks/Logo'
import { route } from '@helpers'
import useSidepanel from '@hooks/useSidepanel'
import { desktop } from '@styles/mixins'
import { colors } from '@styles/vars'
import React from 'react'
import { Link } from 'react-scroll'
import styled, { css } from 'styled-components'
import LandingSidemenu from './components/LandingSidemenu'
import { useSidepanelStateContext } from '@contexts/sidepanel'

export default function LandingHeader() {
    const sidemenu = useSidepanel()
    const state = useSidepanelStateContext()

    const openSidemenu = () => sidemenu.open(LandingSidemenu, {})

    return (
        <HeaderWrapper>
            <Logo />
            <HeaderRight>
                <NavigationWrapper>
                    <Link to="features" smooth={true}>Features</Link>
                    <Link to="salons" smooth={true}>Salons</Link>
                </NavigationWrapper>
                <ButtonWrapper>
                    <Button type="secondary" to={route("signin")}>Sign in</Button>
                </ButtonWrapper>
                <HamburgerWrapper>
                    <Hamburger opened={state === "visible"} action={openSidemenu}/>
                </HamburgerWrapper>
            </HeaderRight>
        </HeaderWrapper>
    )
}

// STYLES
const HeaderWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const HeaderRight = styled.div`
    display: flex;
    align-items: center;

    & > *:not(:last-child) {
        margin-right: 20px;
    }
`

const HamburgerWrapper = styled.div`
    ${desktop(css`
        display: none;
    `)}
`

const ButtonWrapper = styled.div`
    a, button {
        border: 2px solid ${colors.black};
        color: ${colors.black};

        ${desktop(css`
            border: 2px solid ${colors.white};
            color: ${colors.white};

            &:hover {
                color: ${colors.black};
                background: ${colors.white};
                border: 2px solid ${colors.white};
            }
        `)}
    }
`

const NavigationWrapper = styled.div`
    display: none;

    ${desktop(css`
        display: flex;

        a {
            text-decoration: none;
            color: ${colors.white};
            font-weight: 600;
        }

        a:not(:last-child) {
            margin-right: 30px;
        }
    `)}
`